import { atom } from 'jotai';
import { Article } from 'shared/models';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleCategoryPost {
  items: Article[];
  hasMore: boolean;
  cursor: number;
}

type TArticleCategoryPostStore = { [key: string]: Promise<IArticleCategoryPost> | IArticleCategoryPost | undefined };

const $ArticleCategoryPostStore = atom<TArticleCategoryPostStore>({});

export const $ArticleCategoryPost = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleCategoryPostStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: IArticleCategoryPost | Promise<IArticleCategoryPost>) => {
      const old = get($ArticleCategoryPostStore);
      set($ArticleCategoryPostStore, {
        ...old,
        [groupId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleCategoryPost+${encodeURIComponent(groupId)}`;

  return a;
});
